export const apiName: string = 'projetos';
export const projetoRoute: string = 'projeto';
export const projetoStorage: string = 'projeto';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projeto/shared/data.service.ts
 **/